module.exports = __webpack_public_path__ + "img/title.9e0fac80.png";